interface SavedWorkspaceData {
  wsCode: string
  token: string
}
function getTabId() {
  if (!window.name) {
    window.name = `tab-${Date.now()}-${Math.random().toString(36).substring(2)}`
  }
  return window.name
}

export const getAccessTokenInLocalStorage = () => {
  const token = localStorage.getItem("access_token")
  const tokenType = localStorage.getItem("token_type") || "Bearer"
  const tabId = getTabId()
  const saved = localStorage.getItem(`last_ws_data_${tabId}`)
  if (!saved) return `${tokenType} ${token}`
  const data: SavedWorkspaceData = JSON.parse(saved)
  return `${tokenType} ${data.token}`
}
